import { transformGqlToAgeRestriction } from '@/scenarios/legacy-player/lib/transform-age-restriction';

import { getCurrentProgram } from '../../channel-program/utils/get-current-program';
import { getVideoSize } from '../../movie-player/utils/get-video-size';

import { useChannelCurrentStream } from './use-channel-current-stream';
import { useReadChannelPlayerBaseInfo } from './use-read-channel-player-base-info';
import { useReadChannelPrograms } from './use-read-channel-programs';

export const useChannelAgeRestrictionData = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);

    const stream = useChannelCurrentStream(contentId);
    const { videoHeight, videoWidth } = getVideoSize(stream);

    const programs = useReadChannelPrograms(baseInfo);

    const age =
        getCurrentProgram(programs)?.ageRestriction ??
        transformGqlToAgeRestriction(baseInfo?.ageRestriction);

    return {
        age,
        videoWidth,
        videoHeight,
    };
};
